// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"1d04725a","450":"12c23ed3"}[chunkId] + ".chunk.css";
};